/**
 * File Name          : hex-string-utils.ts
 * Author             : Jared Laine Dyreson
 * Version            : 0.0.0
 * Date               : 2026-03-18
 * Description        : Short Description (manual edit required)
 * 
 * Copyright (C) Innovative Design Labs, Inc. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * This file is subject to the terms and conditions defined in
 * file 'IDL_BACKGROUNDTECH_LICENSE.txt', which is part of this source code package.
 */

export class HexStringUtils {
  static stringToHex(str: string): string {
    let hexString = '';
    for (let i = 0; i < str.length; i++) {
        hexString += str.charCodeAt(i).toString(16).padStart(2, '0');
    }
    return hexString;
  }

  static hexToString(hex: string): string {
    let str = '';
    for (let i = 0; i < hex.length; i += 2) {
        const hexCode = hex.substr(i, 2);
        str += String.fromCharCode(parseInt(hexCode, 16));
    }
    return str;
  }
}
